import { Bookmark } from 'lucide-react'

interface FavouriteBookmarkButtonProps {
  isFavourited: boolean
  onClick: () => void
  disabled?: boolean
  className?: string
  ariaLabel?: string
  label?: string
}

export default function FavouriteBookmarkButton({
  isFavourited,
  onClick,
  disabled = false,
  className = '',
  ariaLabel = 'Toggle favourite',
  label,
}: FavouriteBookmarkButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      className={`inline-flex items-center justify-center rounded-full border transition-colors disabled:cursor-not-allowed disabled:opacity-65 ${
        isFavourited
          ? 'border-blue bg-blue text-white hover:bg-blue/90'
          : 'border-blue bg-surface text-blue hover:bg-blue/10'
      } ${className}`}
    >
      <Bookmark className="h-5 w-5" aria-hidden />
      {label && <span className="text-sm font-semibold">{label}</span>}
    </button>
  )
}
